export const PrimaryCategories = [
  'Animals & Pet Supplies',
  'Apparel & Accessories',
  'Arts & Entertainment',
  'Baby & Toddler',
  'Business & Industrial',
  'Electronics',
  'Food Beverages & Tobacco',
  'Furniture',
  'Hardware',
  'Health & Beauty',
  'Home & Garden',
  'Luggage & Bags',
  'Media',
  'Office Supplies',
  'Shoes',
  'Software',
  'Sporting Goods',
  'Toys & Games',
  'Vehicles & Parts'
]
